// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3Ra1G","obliqueLineWrap":"membershipbadge_obliqueLineWrap__18pmi","obliqueLine":"membershipbadge_obliqueLine__SwMTr"};